import { render, staticRenderFns } from "./ParticipantReseller.vue?vue&type=template&id=5ed5dbbb"
import script from "./ParticipantReseller.vue?vue&type=script&lang=js"
export * from "./ParticipantReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports